__turbopack_context__.v({
  "sizer": "stacked-banner-carousel-module__MmuXBG__sizer",
  "slide": "stacked-banner-carousel-module__MmuXBG__slide",
  "stack": "stacked-banner-carousel-module__MmuXBG__stack",
});
